import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Button, USER_PERMISSIONS } from 'dyl-components';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RestrictedView from 'shared/RestrictedView';

const UserAccountsToolbar = () => {
    const canAddTerritories = useSelector((state) => (state.territory.territories || []).length < 25);

    return (
        <div className='TerritoryOptions'>
            <RestrictedView userPermission={USER_PERMISSIONS.TERRITORIES_ADD} type="disabled">
                <Button disabled={!canAddTerritories} as={Link} to='/settings/territories/create' className='TerritoryOptions__NewTerritory'>
                    <Icon name='plus' /> New Territory
                </Button>
            </RestrictedView>
        </div>
    );
}

export default UserAccountsToolbar;
